'use strict';

(function ($, Drupal, drupalSettings, undefined) {
    if (!window._)
        return

    var elements = $('.effect--parallax').children();

    var isInViewPort = function isInViewPort(el) {
        var rect = el.getBoundingClientRect();

        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    };

    var parallaxBackground = _.throttle(function () {
        var scrolltop = window.pageYOffset || document.documentElement.scrollTop; // get number of pixels document has scrolled vertically

        elements.map(function (i, element) {

            if (!isInViewPort(element)) return;

            var parent = $(element, this[i]).closest('.effect--reveal');

            var elementMiddle = parent.offset().top + parent.innerHeight() * .5;
            var distanceToMiddleOfElement = scrolltop - elementMiddle + $(window).height() * .5;

            // var sign = Math.sign(distanceToMiddleOfElement);
            var absDist = Math.min(distanceToMiddleOfElement * 0.02, 50);

            $(element, this[i]).css({ transform: 'translate3d( 0, ' + absDist + '%, 0) scale3d(1, 1, 1)' });
        });
    }, 16);
})(jQuery, Drupal, drupalSettings);
